import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 25 23"

const FavoritesIconFilled = createSvgIcon(
  <>
    <g id='Header---AE-Only' stroke='none' strokeWidth='1'>
      <g id='1024---PTP' transform='translate(-887 -62)'>
        <g id='Utility-Nav' transform='translate(723 59)'>
          <path
            d='M187.508 9.917a5.876 5.876 0 00-5.879-5.878c-2.359 0-4.37 1.353-5.298 3.364l-.039-.038-.038.038c-.078-.077-.116-.116-.116-.193a5.927 5.927 0 00-5.26-3.21A5.876 5.876 0 00165 9.878c0 1.508.58 2.9 1.508 3.945l9.746 11.447 9.745-11.447c.928-1.044 1.509-2.398 1.509-3.906z'
            id='Favorites'
          />
        </g>
      </g>
    </g>
  </>,
  'FavoritesIconFilled'
)

export default FavoritesIconFilled
